import { render, staticRenderFns } from "./DialogPermitStages.vue?vue&type=template&id=f83f562a&"
import script from "./DialogPermitStages.vue?vue&type=script&lang=js&"
export * from "./DialogPermitStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports